import { render, staticRenderFns } from "./trangChu2.vue?vue&type=template&id=32b3b2a6&"
import script from "./trangChu2.vue?vue&type=script&lang=js&"
export * from "./trangChu2.vue?vue&type=script&lang=js&"
import style0 from "./trangChu2.vue?vue&type=style&index=0&id=32b3b2a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports